export function getStartTimeAtLocation(date: Date, offset: string) {
  const offset_parts = offset.split(':')
  const offsetHours = parseInt(offset_parts[0], 10)
  const offsetMinutes = parseInt(offset_parts[1], 10)
  const hours = date.getUTCHours() + offsetHours
  const minutes = date.getUTCMinutes() + offsetMinutes
  return (hours + '').padStart(2, '0') + ':' + (minutes + '').padStart(2, '0')
}

export function getStartTimeAtGermany(date: Date) {
  return date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
}

export function getFullTime(date: Date, offset: string) {
  const userTime = getStartTimeAtGermany(date)
  const locationTime = getStartTimeAtLocation(date, offset)
  return `${userTime} Uhr (${locationTime} Uhr Ortszeit)`
}
